module.exports = __webpack_public_path__ + "img/index.1cf6e641.png";